import './main.css'
import '../App.css'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faGem, faGamepad } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../Pages/messageModal';
import { ChevronRight } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from './common/function';
import { useTranslation } from "react-i18next";
import { checkDuplicateLogins } from '../store';
import dayjs from 'dayjs';

function Memories() {
    const { t } = useTranslation();
    let JWT = useSelector((state) => { return state.JWT.value })
    const [memoriesList, setMemoriesList] = useState([])
    const [superList, setSuperList] = useState([])
    const [tab, setTab] = useState(0)

    let dispatch = useDispatch();

    useEffect(() => {
        MemoriesData()
        SuperJackpotData()
    }, [])

    const MemoriesData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/jackpot', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            // console.log(tmp)
            if (tmp?.code == 1000) {
                setMemoriesList(tmp?.data?.jackpot ?? [])
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const SuperJackpotData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/super-jackpot/history', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setSuperList(tmp?.data?.history ?? [])
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    return (
        <div className='main notheader'>
            <div className='memories'>
                <div className='settings-header'>{t('memories_0')}</div>
                <div className='settings-subheader'>{t('memories_1')}</div>
                <div className='airdrop-tab'>
                    <div className={`airdrop-tab-item ${tab === 0 ? "active" : ""}`} onClick={() => setTab(0)}>Jackpot</div>
                    <div className={`airdrop-tab-item ${tab === 1 ? "active" : ""}`} onClick={() => setTab(1)}>Super Jackpot</div>
                </div>
                <div className=''>
                    {
                        tab == 0
                            ?
                            memoriesList.length === 0
                                ?
                                <div className='friend-list-1-2'>
                                    {t('memories_2')}
                                </div>
                                :
                                memoriesList.map(function (a, i) {
                                    return (
                                        <>
                                            <MemoriesItem key={i} item={a} />
                                        </>
                                    )
                                })
                            :
                            superList.length === 0
                                ?
                                <div className='friend-list-1-2'>
                                    {t('memories_2')}
                                </div>
                                :
                                <>
                                    {superList.map(function (a, i) {
                                        return (
                                            <>
                                                <SuperJackpotItem key={i} item={a} />
                                            </>
                                        )
                                    })
                                    }
                                </>
                    }
                </div>
            </div>
        </div>

    )
}

function MemoriesItem({ item }) {
    const createdAt = dayjs(item.created_at);
    const isToday = createdAt.isSame(dayjs(), 'day');
    const formattedDate = isToday
        ? createdAt.format('HH:mm:ss')
        : createdAt.format('YYYY-MM-DD');

    return (
        <div className={`memories-list`}>
            {
                item.awarded_amount >= 3000
                    ?
                    item.awarded_amount >= 4000
                        ?
                        <img src='/newImg/icon_goldenbox_big.png' style={{ width: "38px" }} />
                        :
                        <img src='/newImg/icon_goldenbox_medium.png' style={{ width: "38px" }} />
                    :
                    <img src='/newImg/icon_goldenbox_small.png' style={{ width: "38px" }} />
            }
            <div className='memories-list-text' style={{ width: "100%" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: "100%" }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "20px" }} />
                        <div style={{ paddingLeft: "5px" }}>
                            <div className="fontNumber" style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeNum(item.awarded_amount ?? 0)}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ fontSize: "12px" }}>{formattedDate}</div>
                </div>
            </div>
        </div>
    )
}

function SuperJackpotItem({ item }) {
    const createdAt = dayjs(item.sj_win_date);
    const isToday = createdAt.isSame(dayjs(), 'day');
    const formattedDate = isToday
        ? createdAt.format('HH:mm:ss')
        : createdAt.format('YYYY-MM-DD');

    return (
        <div className={`memories-list`} style={{ gap: "5px" }}>
            <img src='/newImg/ticket.png' style={{ height: "38px" }} />

            <div className='memories-list-text' style={{ width: "100%" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: "100%" }}>
                    <div style={{ display: 'flex', alignItems: 'center', position: "relative" }}>
                        {item?.image_path && (
                            <img
                                src={item?.image_path}
                                alt=""
                                style={{ height: 32, display: "block" }}
                            />
                        )}
                        <div
                            style={{
                                position: "absolute",
                                left: "0",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                                fontFamily: "'Roboto Mono', monospace",
                                fontSize: 13,
                                fontWeight: 400,
                                color: item?.image_path ? "#000" : "#fff",
                                whiteSpace: "pre",
                            }}>{item?.sj_name ?? ""}</div>
                    </div>
                    <div style={{ fontSize: "12px" }}>{formattedDate}</div>
                </div>
            </div>
        </div>
    )
}

function SuperJackpotItem1({ }) {
    const balls = [10, 12, 16, 20, 30, 40];
    return (
        <div className={`memories-list`} style={{ gap: "5px" }}>
            <img src='/newImg/ticket.png' style={{ height: "38px" }} />

            <div className='memories-list-text' style={{ width: "100%" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: "100%" }}>
                    <div style={{ position: "relative", display: "inline-block" }}>
                        <img
                            src="/newImg/jackpot_bg.png"
                            alt=""
                            style={{ height: 32, display: "block" }}
                        />

                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                placeItems: "center",
                                pointerEvents: "none",
                                fontFamily: "'Roboto Mono', monospace",
                                fontSize: 13,
                                fontWeight: 600,
                                color: "#000",
                            }}
                        >
                            {balls.map(n => <span key={n}>{n}</span>)}
                        </div>
                    </div>
                    <div style={{ fontSize: "12px" }}>{123123}</div>
                </div>
            </div>
        </div>
    )
}

export default Memories;